import { useSelector } from 'react-redux';
import { BoxEffectContainer, Title } from './BoxEffects.style';
import { selectedVocalEffectSelector } from '@redux/featureFlags/selector';
import { VocalEffects } from 'constants/vocalPresets';
import { FormattedMessage } from 'react-intl';
import analytics from 'lib/analytics';

interface Props {
  effect: string;
  color: string;
  translationId: string;
  Icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  onClick: (effect: VocalEffects) => void;
}

export function BoxEffect({ effect, color, Icon, onClick, translationId }: Props) {
  const selectedEffect = useSelector(selectedVocalEffectSelector);

  const handleToggleVoiceModification = async (effect: string) => {
    const vocalEffect = effect as VocalEffects;
    if (effect === selectedEffect) {
      analytics.track('VocalEffect_Stop', { value: vocalEffect });
      return onClick(VocalEffects.DEFAULT);
    }
    analytics.track('VocalEffect_Start', { value: vocalEffect });
    onClick(vocalEffect);
  };

  return (
    <BoxEffectContainer
      color={color}
      isSelected={effect === selectedEffect}
      onClick={() => handleToggleVoiceModification(effect)}
    >
      <Title>
        <FormattedMessage id={translationId} />
      </Title>
      <Icon />
    </BoxEffectContainer>
  );
}
